/** Must be in sync with fleet backend equivalent enum  */
export enum EMap {
	LineString = 'LineString',
	Feature = 'Feature',
	FeatureCollection = 'FeatureCollection',
	Point = 'Point',
	lineJoin = 'line-join',
	lineCap = 'line-cap',
	round = 'round',
	bevel = 'bevel',
	miter = 'miter',
	butt = 'butt',
	square = 'square',
	none = 'none',
	lineColor = 'line-color',
	lineWidth = 'line-width',
	lineOpacity = 'line-opacity',
	geojson = 'geojson',
	routeData = 'route-data',
	routeLayer = 'route-layer',
	line = 'line',
	symbol = 'symbol',
	markerSymbols = 'marker-symbols',
	placeholder = 'placeholder',
	get = 'get',
	icon = 'icon',
	iconImage = 'icon-image',
	iconAllowOverlap = 'icon-allow-overlap',
	iconIgnorePlacement = 'icon-ignore-placement',
	iconSize = 'icon-size',
	styleLoad = 'style.load',
	style = 'mapbox://styles/mapbox/streets-v12',
}
